export default {
    data() {
        return {

        }
    },
    methods: {
        format(t, gsh) {
            if (t == undefined || t == '' || t == null) {
                t = new Date();
            }
            if (gsh == undefined || gsh == '' || gsh == null) {
                gsh = "yyyy-MM-dd";
            }
            Date.prototype.Format = function (fmt) { //author: meizz
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小时
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    "S": this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            }
            return t.Format(gsh);
        },
        getWeekStart(t, v, d) {
            //获取本周的周一
            let nowTemp = new Date(t.replace(/-/g, "/") + " 00:00:00"); //当前时间
            let oneDayLong = 24 * 60 * 60 * 1000; //一天的毫秒数
            let c_time = nowTemp.getTime(); //当前时间的毫秒时间
            let c_day = nowTemp.getDay() || 7; //当前时间的星期几
            let m_time = c_time - (c_day - 1) * oneDayLong; //当前周一的毫秒时间
            let monday = new Date(m_time); //设置周一时间对象
            let weekend = new Date(m_time + 6 * oneDayLong); //设置周一时间对象
            if (d) {
                let yc = new Date(this.getMonthStart(t).replace(/-/g, "/") + " 00:00:00").getTime()
                let yw = new Date(this.getMonthStart(t, true).replace(/-/g, "/") + " 00:00:00").getTime()
                monday = m_time < yc ? new Date(yc) : monday
                weekend = (m_time + 6 * oneDayLong) > yw ? new Date(yw) : weekend
            }

            if (v) {
                return this.format(weekend, "yyyy-MM-dd");
            } else {
                return this.format(monday, "yyyy-MM-dd");
            }
        },
        getMonthStart(t, v) {//当前日期所在月的月初和月尾
            let nowTemp = t.split('-')
            let start = this.format(new Date(nowTemp[0] + "/" + nowTemp[1] + "/" + "01 00:00:00"), "yyyy-MM-dd")
            let end = this.format(new Date(nowTemp[0], parseInt(nowTemp[1]), 0), "yyyy-MM-dd")
            if (v) {
                return end
            } else {
                return start
            }
        },
        getWeekInMonth(t) {//当前日期是本月第几周
            if (t == undefined || t == '' || t == null) {
                t = new Date();
            }
            t = new Date(t.replace(/-/g, "/") + " 00:00:00");
            var _t = new Date();
            _t.setYear(t.getFullYear());
            _t.setMonth(t.getMonth());
            _t.setDate(t.getDate());

            var date = _t.getDate(); //给定的日期是几号

            _t.setDate(1);
            var d = _t.getDay(); //1. 得到当前的1号是星期几。
            var fisrtWeekend = d;
            if (d == 0) {
                fisrtWeekend = 1;
                //1号就是星期天
            } else {
                fisrtWeekend = 7 - d + 1; //第一周的周未是几号
            }
            if (date <= fisrtWeekend) {
                return 1;
            } else {
                return 1 + Math.ceil((date - fisrtWeekend) / 7);
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/date.js